export const PERMISSIONS = {
    // Team Lead
    CALL_SVC_TEAM_LEAD_BASE: "CALL_TL1",

    // Admin
    CALL_SVC_ADMIN_BASE: "CALL_AD1",
    CALL_CALL_DETAIL_ACTIONS: "CALL_AD2",

    // Calls
    /** Sidebar: Calls. Dashboard: Last calls widget. */
    CALL_READ_CALLS: "CALL_RC1",
    /** Calls page: team member selector. */
    CALL_CALLS_SELECT_MEMBER: "CALL_RC2",
    /** Calls page: All agents (global) view. */
    CALL_CALLS_GLOBAL_SEARCH: "CALL_CG1",
    /** Call details: Evaluation tab. */
    CALL_CALL_EVALUATION: "CALL_EV1",

    // Dialer
    /** Right sidebar / mobile dialer. */
    CALL_DIALER: "CALL_DI1",

    // Setting lists
    /** Sidebar: Lists. */
    CALL_SETTING_LISTS: "CALL_LS1",

    // Scripts
    /** Sidebar: Scripts. */
    CALL_SCRIPTS_READ: "CALL_SR1",

    // KPIs
    /** Sidebar: Performance → KPIs. Dashboard: Today's performance widget. */
    CALL_KPIS_READ: "CALL_KP1",
    /** KPIs page: team member selector. */
    CALL_KPIS_SELECT_MEMBER: "CALL_KP2",

    // Appointments
    /** Appointments page: team member selector. */
    CALL_APPOINTMENTS_SELECT_MEMBER: "CALL_AP1",

    // Calendar capacities
    /** Sidebar: Calendar Capacities. Dashboard: Calendar capacities widget. */
    CALL_CALENDAR_CAPACITIES: "CALL_CC1",

    // Calendar (legacy)
    CALL_CALENDAR_CREATE: "CALL_CA1",
    CALL_CALENDAR_UPDATE: "CALL_CA2",
    CALL_CALENDAR_DELETE: "CALL_CA3",
    CALL_CALENDAR_READ: "CALL_CA4", // Dashboard: Upcoming appointments widget. Sidebar: Appointments.

    // Calendar bookings
    CALL_CALENDAR_BOOKING_READ: "CALL_CB1",
    CALL_CALENDAR_BOOKING_READ_ME: "CALL_CB2",
    CALL_CALENDAR_BOOKING_MANAGE: "CALL_CB3",

    CALL_CALENDAR_PLAN_CREATE: "CALL_CP1",
    CALL_CALENDAR_PLAN_READ: "CALL_CP2",
    CALL_CALENDAR_PLAN_DELETE: "CALL_CP3",
    CALL_CALENDAR_PLAN_UPDATE: "CALL_CP4",

    // Event types
    CALL_EVENT_TYPE_READ: "CALL_ET1",
    CALL_EVENT_TYPE_CREATE: "CALL_ET2",
    CALL_EVENT_TYPE_UPDATE: "CALL_ET3",
    CALL_EVENT_TYPE_DELETE: "CALL_ET4",

    // Setting
    CALL_SETTING_PRIORITY_COUNTS: "CALL_SP1", // GET /setting/priority-counts — Dashboard: Priority Report widget
    CALL_SETTING_DELETE_LEAD: "CALL_SP2", // DELETE /lead/:brandName for stale local leads
    /** Priority report: open/view the leads list from overview cells. */
    CALL_SETTING_PRIORITY_READ_LEADS: "CALL_SP3",

    // Pinned agents
    /** Dashboard: Pinned agents widget. */
    CALL_PINNED_AGENTS: "CALL_PN1",
    /** Pinned agents: add, remove, and reorder. */
    CALL_PINNED_AGENTS_MANAGE: "CALL_PN2",

    // Agent performance dashboard
    CALL_DASHBOARD_AGENT_PERFORMANCE: "CALL_DP1",

    // Incidents
    /** Notes API + sidebar Incidents + dashboard Pending incidents widget */
    INCIDENT_REPORT_NOTES: "CALL_IN1",

    // Performance reports
    CALL_REPORTS_PRP_ADMIN: "CALL_RP1",
    CALL_REPORTS_SALES_ADMIN: "CALL_RS1",

    /** Sidebar: Performance → Reachability analysis. */
    CALL_REACHABILITY_ANALYSIS: "CALL_RA1",

    // Data export - weekly call/transcript extracts
    CALL_DATA_EXPORT_DOWNLOAD: "CALL_DE1",

    // CRM contacts - local copy synced from the Zoho Contacts module
    CALL_CONTACTS_READ: "CALL_CO1",

    // Hotel
    CALL_HOTEL_BASE: "CALL_HO1",

    /** Sidebar: Telli. View and run the Telli AI calling worker (setting team leads). */
    CALL_TELLI_MANAGE: "CALL_TE1",
};
